import React from 'react';
import Buttons from '../Common/Buttons';
import Ticks from '../Common/Ticks';
import { useLocale } from '../../localization/LocaleContext';
import '../NicheLanding/NicheLandingPage.css';

function InvoiceMockup({ t }) {
    return (
        <div className="niche-invoice-mockup">
            <div className="niche-invoice-header">
                <div className="niche-invoice-logo-placeholder">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 21h18"/>
                        <path d="M5 21V7l7-4 7 4v14"/>
                        <path d="M9 21v-6h6v6"/>
                        <path d="M9 9h1"/>
                        <path d="M14 9h1"/>
                        <path d="M9 13h1"/>
                        <path d="M14 13h1"/>
                    </svg>
                </div>
                <div>
                    <div className="niche-invoice-title-text">INVOICE</div>
                    <div className="niche-invoice-number">#INV-2026-0291</div>
                </div>
            </div>
            <div className="niche-invoice-divider" />
            <div className="niche-invoice-parties">
                <div>
                    <div className="niche-invoice-label">{t('organization.invoiceFrom')}</div>
                    <div className="niche-invoice-name">{t('organization.invoiceSender')}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <div className="niche-invoice-label">{t('organization.invoiceTo')}</div>
                    <div className="niche-invoice-name">{t('organization.invoiceRecipient')}</div>
                </div>
            </div>
            <div className="niche-invoice-table">
                <div className="niche-invoice-table-header">
                    <span>{t('organization.invoiceItemHeader')}</span>
                    <span>{t('organization.invoiceAmountHeader')}</span>
                </div>
                <div className="niche-invoice-table-row">
                    <span>{t('organization.invoiceItem1')}</span>
                    <span>{t('organization.invoiceItem1Price')}</span>
                </div>
                <div className="niche-invoice-table-row">
                    <span>{t('organization.invoiceItem2')}</span>
                    <span>{t('organization.invoiceItem2Price')}</span>
                </div>
            </div>
            <div className="niche-invoice-total-row">
                <span className="niche-invoice-total-label">Total</span>
                <span className="niche-invoice-total-value">{t('organization.invoiceTotal')}</span>
            </div>
            <div className="niche-invoice-status">{t('organization.invoiceStatus')}</div>
        </div>
    );
}

function Banner(){
    const { t } = useLocale();

    return(
        <section className="niche-hero sp-60">
            <div className="container">
                <div className="row flex-column-reverse flex-lg-row align-items-center">
                    <div className="col-lg-6">
                        <h1 className="h-1 h-bold niche-hero-title">
                            {t('organization.bannerTitleStart')}{' '}
                            {t('organization.bannerTitleMiddle')}{' '}
                            <span className="niche-hero-highlight">{t('organization.bannerTitleHighlight')}</span>
                        </h1>
                        <p className="niche-hero-description">
                            {t('organization.bannerSubtitle')}
                        </p>
                        <Buttons />
                        <div className="mt-20">
                            <Ticks />
                        </div>
                    </div>
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <InvoiceMockup t={t} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Banner;